import api from './index';

const tvCommandsApi = api.injectEndpoints({
  endpoints: build => ({
    /**
     * LIST flows with optional filters.
     * GET /api/v1/tv-commands
     */
    getTvCommands: build.query({
      query: params => {
        // params can be undefined or an object of query params
        const qs = new URLSearchParams();

        if (params && typeof params === 'object') {
          const keys = [
            'type',
            'name',
            'adSlots',
            'osvs',
            'make',
            'adTypes',
            'destTypes',
            'countries',
          ];

          keys.forEach(k => {
            const v = params[k];
            if (v === undefined || v === null || v === '') return;

            // allow passing arrays or comma-separated strings
            if (Array.isArray(v)) {
              if (v.length > 0) qs.set(k, v.join(','));
            } else {
              qs.set(k, String(v));
            }
          });
        }

        const queryString = qs.toString() ? `?${qs.toString()}` : '';
        return {
          url: `/api/v1/tv-commands${queryString}`,
          method: 'GET',
        };
      },
      providesTags: result =>
        result?.length
          ? [
              ...result.map(doc => ({
                type: 'tvCommands',
                id: doc._id,
              })),
              { type: 'tvCommands', id: 'LIST' },
            ]
          : [{ type: 'tvCommands', id: 'LIST' }],
    }),

    /**
     * GET one flow by id
     * GET /api/v1/tv-commands/:id
     */
    getTvCommandById: build.query({
      query: id => ({
        url: `/api/v1/tv-commands/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'tvCommands', id }],
    }),

    /**
     * CREATE flow
     * POST /api/v1/tv-commands
     */
    createTvCommand: build.mutation({
      query: body => ({
        url: `/api/v1/tv-commands`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'tvCommands', id: 'LIST' }],
    }),

    /**
     * PATCH flow (partial update)
     * PATCH /api/v1/tv-commands/:id
     */
    updateTvCommand: build.mutation({
      query: ({ id, body }) => ({
        url: `/api/v1/tv-commands/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'tvCommands', id: arg.id },
        { type: 'tvCommands', id: 'LIST' },
      ],
    }),

    /**
     * DELETE flow
     * DELETE /api/v1/tv-commands/:id
     */
    deleteTvCommand: build.mutation({
      query: id => ({
        url: `/api/v1/tv-commands/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'tvCommands', id },
        { type: 'tvCommands', id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTvCommandsQuery,
  useGetTvCommandByIdQuery,
  useCreateTvCommandMutation,
  useUpdateTvCommandMutation,
  useDeleteTvCommandMutation,
} = tvCommandsApi;
